import styled from 'styled-components';
import { Button } from '@components/form-elements/buttons/Button';

const ModalWrapper = styled.div`
  background: #ffffff;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  position: relative;
  padding: 30px;
  text-align: center;
  max-width: 440px;

  & .content {
    display: flex;
    justify-content: space-between;
    grid-gap: 60px;
  }

  h2 {
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    color: #858dbd;
    margin: 0;
  }

  p.description {
    color: #00122d;
    margin: 30px 0;
  }

  .buttonContainer {
    width: 300px;
    display: flex;
    grid-gap: 10px;
    margin: 0 auto;
  }
`;

type TProps = {
  onCancel: () => void;
  title?: string;
  message: string | React.ReactNode;
};

export const GenericErrorModal = ({ onCancel, message, title = 'Error' }: TProps) => (
  <ModalWrapper>
    <h2>{title}</h2>
    <p className="description">{message}</p>
    <div className="buttonContainer" style={{ width: '100px' }}>
      <Button type="button" variant="contained" onClick={onCancel}>
        Ok
      </Button>
    </div>
  </ModalWrapper>
);
